export default {
  name: "Application Documents",
  pageInfo: {
    text: "<i>Below, you will find a summary of documents that you have uploaded to this application throughout the form. You may also add and categorize additional supplemental documents below.</i>",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "files",
          widget: "application_documents",
          validate: [],
          checkDocuments: [
            "a6_emergency_justification",
            "b16_contract_attached",
            "d20_agent_agreement_attached",
            "ef_1_assurance_attached",
            "ef_2_assurance_attached",
          ],
          modal: {
            machine_name: "application_documents",
            name: "Application Documents",
            widget: "file_upload",
            // label:
            //   "<span>Read and agree to all the application terms, assurances, and obligations contained in <u>Appendix A</u> and attach a signed and dated copy with this application.</span>",
            fileTypes: [".pdf", ".png", ".jpg"],
          },
        },
      ],
    },
  ],
};
